import { HttpLink } from '@apollo/client';
import { BatchHttpLink } from '@apollo/client/link/batch-http';
const BATCH_MAX = 10;
const BATCH_INTERVAL = 100;
const shouldUseBatch = (operation) => {
    var _a, _b, _c;
    const operationContext = operation.getContext();
    return (_c = (_b = (_a = operationContext === null || operationContext === void 0 ? void 0 : operationContext.linkOptions) === null || _a === void 0 ? void 0 : _a.batchLink) === null || _b === void 0 ? void 0 : _b.enableBatch) !== null && _c !== void 0 ? _c : false;
};
// "private" Helper with Link types abstracted, for unit testing.
export const _createChainHttpLink = (httpLinkImpl, batchHttpLinkImpl) => (currentLink, apiEndpoint, includeCredentials) => {
    // node-fetch and apollo-link are weird but this should work fine. https://github.com/apollographql/apollo-link/issues/513
    const opts = { uri: apiEndpoint };
    if (includeCredentials) {
        opts['credentials'] = 'include';
    }
    const httpLink = new httpLinkImpl(opts);
    const batchHttpLink = new batchHttpLinkImpl(Object.assign(Object.assign({}, opts), { batchMax: BATCH_MAX, batchInterval: BATCH_INTERVAL }));
    return currentLink.split(shouldUseBatch, batchHttpLink, httpLink);
};
/*
 The terminating Link which provides the HTTP interface of choice. The caller can switch between the standard HttpLink & the BatchHttpLink
 based on the value in context.
*/
export const chainHttpLink = _createChainHttpLink(HttpLink, BatchHttpLink);
